import 'dayjs/locale/en';

import dayjs from 'dayjs';
import durationPlugin from 'dayjs/plugin/duration';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTimePlugin from 'dayjs/plugin/relativeTime';
import utcPlugin from 'dayjs/plugin/utc';

dayjs.extend(utcPlugin);
dayjs.extend(durationPlugin);
dayjs.extend(relativeTimePlugin);
dayjs.extend(localizedFormat);

export type Replacement = {
  key: string;
  value: string;
};

export function getRemainingTime(utcDueDate: Date): string {
  const dueDate = dayjs(dayjs.utc(utcDueDate).local());
  const diffDuration = dayjs.duration(dueDate.diff(dayjs()));

  const diffAsMinutes = diffDuration.asMinutes();
  const diffAsHours = diffDuration.asHours();
  const diffAsDays = diffDuration.asDays();

  const diffMinutes = diffDuration.minutes();
  const diffHours = diffDuration.hours();
  const diffDays = diffDuration.days();
  const diffWeeks = diffDuration.weeks();

  const remainingDiffDays = diffDays % 7;

  if (diffAsMinutes < 1) {
    return `<1min`;
  }

  if (diffAsMinutes >= 1 && diffAsHours < 1) {
    return `${diffMinutes}min`;
  }

  if (diffAsHours >= 1 && diffAsDays < 1) {
    return diffMinutes === 0
      ? `${diffHours}h`
      : `${diffHours}h ${diffMinutes}min`;
  }

  if (diffAsDays >= 1 && diffAsDays < 7) {
    return diffHours === 0 ? `${diffDays}d` : `${diffDays}d ${diffHours}h`;
  }

  return remainingDiffDays === 0
    ? `${diffWeeks}w`
    : `${diffWeeks}w ${remainingDiffDays}d`;
}

export function formatDate(date: Date | string | null, locale = 'en') {
  const dateToFormat = date ?? new Date();
  return dayjs(dateToFormat).locale(locale).format('L [at] LT');
}

export function replacePatterns(
  text: string,
  replacements: Replacement[]
): string {
  const everyoneTagReplaceText = text.replace(
    /@__tag:everyone__@/g,
    '@everyone'
  );

  const taskReplacedText = replacements.reduce((acc, { key, value }) => {
    const pattern = `@__task:${key}__@`;
    return acc.split(pattern).join(`${value}`);
  }, everyoneTagReplaceText);

  return replacements.reduce((acc, { key, value }) => {
    const pattern = `@__${key}__@`;
    return acc.split(pattern).join(`@${value}`);
  }, taskReplacedText);
}
